/**
 * Url module contains some static convenience methods for handling URL's like retrieving URL parameters values.
 */

/**
 * Returns all the URL variables key/value pair representation.
 *
 * @returns {Object} - Key/value pair representation of the URL variables.
 */
export function getUrlVars(): any {
    return deParam(window.location.href);
}

/**
 * Parse the given URL and its parameters and return it in an Object.
 *
 * @param urlParams - the URL containing the URL parameters.
 * @returns {{}} - the Object containing the key/value representation of the URL variables.
 */
export function deParam(urlParams: string): any {
    const vars = {};
    urlParams.replace(/[#?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
        vars[key] = value.replace(/\+/g, ' ');
        return "";
    });

    return vars;
}
